export default __webpack_public_path__ + "static/media/fa-bg2.e44d16c3.jpg";